Apt.fn.make('wishlists', {
	/**
	 * Initialize module
	 */
	init: function() {
		var priv = this.$private;

		priv.bindList()
		priv.bindShare();
		priv.bindSelection();
		priv.bindItems();
		priv.bindReorder();
		priv.bindExport();
	},

	/**
	 * Toggle wishlist item state
	 *
	 * @param {String} itemId
	 * @param {Number} [listId]
	 * @param {Function} [fn]
	 */
	toggle: function(itemId, listId, fn) {
		var scope = this;

		if (scope.$has('list', itemId)) {
			scope.remove(itemId, listId, fn);
		} else {
			scope.add(itemId, listId, fn);
		}
	},

	/**
	 * Add wishlist items
	 *
	 * @param {(Array|String)} itemId
	 * @param {Number} [listId]
	 * @param {Function} [fn]
	 */
	add: function(itemId, listId, fn) {
		var scope = this,
			items = {};

		// Always work with the primitive value for guests
		var isGuest = !scope.$get('userId');
		var idPrimitive = Array.isArray(itemId) ? itemId[0] : itemId;

		itemId = $.toArray(itemId);

		itemId.forEach(function(value, index) {
			items[index] = {
				elementId: value
			};

			// Only add listId if it has a numeric value and user is logged in
			if (listId !== null && listId !== undefined && scope.$get('userId')) {
				items[index].listId = listId;
			}
		});

		Apt.auth.token(function(token) {
			$.fetch.request({
				method: 'post',
				url: '/',
				json: true,
				type: 'form',
				data: {
					action: 'wishlist/items/add',
					items: items,
					// Only include listId for logged-in users
					...(listId && scope.$get('userId') ? { listId: listId } : {}),
					CRAFT_CSRF_TOKEN: token
				},
				success: function(data) {
					if (data.error) {
						Apt.flash.error(data.error);
						return;
					}

					if (isGuest) {
						// Guest: ensure the list is an array and add the primitive itemId
						if (!Array.isArray(scope.$get('list'))) {
							scope.$set('list', []);
						}
						scope.$push('list', idPrimitive);
					} else {
						// Logged-in: use $merge as before (if needed for object-based lists)
						scope.$merge('list', itemId);
					}

					scope.$private.indicate();

					Apt.flash.success('Successfully added to wishlist');

					if (fn) {
						fn(true);
					}
				},
				error: function(data) {
					Apt.flash.error(data.error || 'Unable to add to wishlist');
				}
			});
		});
	},

	/**
	 * Remove wishlist items
	 *
	 * @param {(Array|String)} itemId
	 * @param {Number} [listId]
	 * @param {Function} [fn]
	 */
	remove: function(itemId, listId, fn, fromQuantityZero) {
		// Always work with the primitive value for guests
		var scope = this;
		var isGuest = !scope.$get('userId');
		var idPrimitive = Array.isArray(itemId) ? itemId[0] : itemId;

		var items = {};

		itemId = $.toArray(itemId);

		itemId.forEach(function(value, index) {
			items[index] = {
				elementId: value,
			};

			if (fromQuantityZero) {
				items[index].itemId = value;
			}

			// Only add listId if it has a numeric value and user is logged in
			if (listId !== null && listId !== undefined && scope.$get('userId')) {
				items[index].listId = listId;
			}
		});

		Apt.auth.token(function(token) {
			$.fetch.request({
				method: 'post',
				url: '/',
				json: true,
				type: 'form',
				data: {
					action: 'wishlist/items/remove',
					items: items,
					CRAFT_CSRF_TOKEN: token
				},
				success: function(data) {
					if (data.error) {
						Apt.flash.error(data.error);
						return;
					}

					if (isGuest) {
						// Guest: remove the primitive itemId
						scope.$drop('list', idPrimitive);
					} else {
						// Logged-in: use $drop as before
						scope.$drop('list', itemId);
					}

					scope.$private.indicate();

					Apt.flash.success('Successfully removed from wishlist');

					if (fn) {
						fn();
					}

				},
				error: function(data) {
					Apt.flash.error(data.error || 'Unable to remove from wishlist');
				}
			});
		});
	},

	/**
	 * Bind wishlist events
	 *
	 * @param {String} namespace
	 * @param {String} delegate
	 */
	bind: function(namespace, delegate) {
		var scope = this;

		$$('catalogWishlist').on('click', function(e, el) {
			var $el = $(el),
				itemId = $el.parent().data('id');

			if (scope.$get('userId')) {
				scope.prompt(itemId, function(state) {
					$el.toggleClass('-is-active', state);
				});

				return;
			}
			scope.toggle(itemId, null, function(state) {
				$el.toggleClass('-is-active', state);
			});
		}, {
			namespace: namespace,
			delegate: delegate || 'ref:results'
		});
	},

	/**
	 * Prompt for wishlist selection
	 *
	 * @param {Number} elementId
	 * @param {Function} [fn]
	 */
	prompt: function(elementId, fn) {
		var scope = this,
			added = [],
			removed = [],
			unchanged;

		Apt.modal.open({
			url: 'wishlists/manage/' + elementId,
			width: 375,
			success: function() {
				var $form = $('.modal.-is-visible').find('[data-ref="wishlistSelection"]'),
					$checks = $('input[type="checkbox"]', $form),
					init = $form.serialize(true),
					original = init.list || [],
					token = init.CRAFT_CSRF_TOKEN;

				// Extract handler binding to a separate method
				scope.bindModalHandlers(elementId, fn);

			},
			onHide: function() {
				if (unchanged) {
					return;
				}

				$.events.reset('wishlistSelection');
				$.events.reset('wishlistCreateForm');
			}
		});
	},

	/**
	 * Bind modal form handlers
	 *
	 * @param {Number} elementId
	 * @param {Function} [fn]
	 */
	bindModalHandlers: function(elementId, fn) {
		var scope = this,
			added = [],
			removed = [],
			unchanged;

		var $form = $('.modal.-is-visible').find('[data-ref="wishlistSelection"]'),
			$checks = $('input[type="checkbox"]', $form),
			init = $form.serialize(true),
			original = init.list || [],
			token = init.CRAFT_CSRF_TOKEN;

		$form.off('submit.wishlistSelection').on('submit.wishlistSelection', function(event) {
		    event.preventDefault();

			var current = $form.serialize(true).list || [];

			unchanged = $.equals(original, current);

			if (unchanged) {
				Apt.modal.close();
				return;
			} else {
				fn && fn(current.length > 0);
				if ($('.wishlist-container').length > 0) {
					window.location.reload();
				}
			}

			current.forEach(function(listId) {
				if (original.indexOf(listId) >= 0) {
					return;
				}

				scope.add(elementId, listId);
				added.push(elementId);
			});

			original.forEach(function(listId) {
				if (current.indexOf(listId) >= 0) {
					return;
				}

				scope.remove(elementId, listId);
				removed.push(elementId);
			});

			Apt.modal.close();
		});

		var $createForm = $('.modal.-is-visible').find('[data-ref="wishlistCreateForm"]');

		$createForm.off('submit.wishlistCreateForm').on('submit.wishlistCreateForm', function(e) {
			e.preventDefault();

			var $input = $createForm.find('input[name="name"]');
			var listName = $input.val().trim();
			var token = $createForm.find('input[name="CRAFT_CSRF_TOKEN"]').val();

			if (!listName) {
				Apt.flash.error('Please enter a name for the new wishlist.');
				return;
			}

			$.fetch.request({
				url: '/',
				method: 'post',
				data: {
					action: 'wishlist/lists/create',
					// Craft expects the title parameter directly
					title: listName,
					CRAFT_CSRF_TOKEN: token
				},
				json: true,
				type: 'form',
				success: function(response) {
					if (response.error || !response.success || !response.id) {
						Apt.flash.error(response.error || 'Unable to create wishlist. No ID returned.');
						return;
					}

					Apt.flash.success('List created successfully!');

					// Reload the modal content to show the new list
					Apt.modal.load({
						url: 'wishlists/manage/' + elementId,
						success: function() {
							// Re-bind event handlers after modal content reload
							scope.bindModalHandlers(elementId, fn);
						}
					});

					// Clear the input field
					$input.val('');
				},
				error: function() {
					Apt.flash.error('An error occurred while creating the wishlist.');
				}
			});
		});
	},

	/**
	 * Highlight wishlist item status
	 */
	highlight: function() {
		Apt.wishlists.fetch(function(list) {
			$$('preview').each(function(el) {
				var $el = $(el);

				if (list.indexOf($el.data('id')) >= 0) {
					$el.find('ref:catalogWishlist').addClass('-is-active');
				}
			});
		});
	},

	/**
	 * Get wishlist list
	 *
	 * @param {Function} fn
	 * @param {Boolean} [force=false]
	 */
	fetch: function(fn, force) {
		this.$private.fetch(fn, force);
	},

	/**
	 * Check if element exists in list
	 *
	 * @param {String} id
	 * @param {Function} fn
	 */
	exists: function(id, fn) {
		var scope = this;

		scope.$private.fetch(function() {
			fn(scope.$has('list', id));
		});
	},

	/**
	 * Unload module
	 */
	unload: function() {
		$.events.reset('wishlists');
	}
}, {
	/**
	 * Fetch wishlists
	 *
	 * @param {Function} [fn]
	 * @param {Boolean} [force=false]
	 */
	fetch: function(fn, force) {
		var scope = this;

		if (! force && scope.$has('list')) {
			if (fn) {
				fn(scope.$get('list'));
			}

			return;
		}

		$.fetch.request({
			url: '/wishlists/list',
			json: true,
			success: function(data) {
				scope.$merge(data);

				var count = data.list.length;

				if (! count) {
					return;
				}

				scope.indicate();

				if (fn) {
					fn(data.list);
				}
			}
		});
	},

	/**
	 * Update wishlist indicator
	 */
	indicate: function() {
		$$('wishlistCount').text(
			this.$get('list').length
		);
	},

	/**
	 * Bind wishlist actions
	 */
	bindList: function() {
		var scope = this;

		$$('wishlistRename').on('submit', function(e) {
			if (! scope.renaming) {
				e.preventDefault();
			}

			scope.renaming = true;

			$$('wishlistRenameInput').show();

			$$('wishlistRenameButton').text('Save Name');
		}, {
			namespace: 'wishlists'
		});

		$$('wishlistCreate').on('submit', function(e) {
			if (! scope.creating) {
				e.preventDefault();
			}

			scope.creating = true;

			$$('wishlistCreateInput').show();

			$$('wishlistCreateButton').text('Create List');
		}, {
			namespace: 'wishlists'
		});

		$$('wishlistDelete').on('submit', function(e) {
			if (! $._win.confirm('Are you sure you want to delete this list?')) {
				e.preventDefault();
			}
		}, {
			namespace: 'wishlists'
		});
	},

	/**
	 * Bind link share
	 */
	bindShare: function() {
		var $button = $$('wishlistShare');

		$button.on('click', function() {
			var url = $$('wishlistUrl')[0];

			url.select();

			$._doc.execCommand('copy');

			$._win.getSelection()
				.removeAllRanges();

			url.blur();

			$button.text('Copied');
		}, {
			namespace: 'wishlists'
		});
	},

	/**
	 * Bind wishlist item selection
	 */
	bindSelection: function() {
		var $items = $$('wishlistCheck'),
			$selection = $$('wishlistSelection'),
			$actions = $$('wishlistActions');

		$items.on('change', function() {
			var checked = $items.filter(':checked').length,
				active = checked > 0;

			$actions.toggleClass('-is-active', active)
				.toggleClass('-is-partial', active && checked !== $items.length);

			$selection.prop('checked', active);
		}, {
			namespace: 'wishlists'
		});

		$selection.on('click', function(e, el) {
			var complete = $items.filter(':checked').length === $items.length;

			if (el.checked || ! complete) {
				el.checked = true;
				$items.prop('checked', true);
				$actions.addClass('-is-active')
					.removeClass('-is-partial');
			} else if (complete) {
				$items.prop('checked', false);
				$actions.removeClass('-is-active');
			}
		}, {
			namespace: 'wishlists'
		});
	},

	/**
	 * Bind wishlist item actions
	 */
	bindItems: function() {
		var scope = this,
			pub = scope.$public;

		$$('wishlistAction').on('change', function(e, el) {
			var $el = $(el.options[el.selectedIndex]),
				action = $el.data('action'),
				items = $$('wishlistCheck').filter(':checked');

			if (! items.length) {
				return;
			}

			items = items.map(function(el) {
				return el.value;
			});

			if (action === 'delete') {
				if (! $._win.confirm('Are you sure you want to delete these items?')) {
					e.preventDefault();
					el.selectedIndex = 0;
					return;
				}
			} else if (action === 'copy' || action === 'move') {
				pub.add(items, $el.attr('value'));
			}

			if (action === 'delete' || action === 'move') {
				pub.remove(items, $.get('listId'), function() {
					$.history.go($._doc.location.pathname);
				});
			}

			el.selectedIndex = 0;
		}, {
			namespace: 'wishlists'
		});

		$$('wishlistQuantity').on('change', function(e, el) {
			if (! el.value) {
				return;
			}


			if (el.value < 1) {
				var itemId = $(el)
				.closest('ref:wishlistItem')
				.data('id');

				if ($._win.confirm('Are you sure you want to delete this item?')) {
					pub.remove(itemId, $.get('listId'), function() {
						$.history.go($._doc.location.pathname);
					}, true);
				} else {
					el.value = 1;
				}

				return;
			}

			Apt.auth.token(function(token) {
				$.fetch.request({
					url: '/',
					method: 'post',
					data: {
						action: 'wishlist/items/update',
						itemId: $(el)
							.closest('ref:wishlistItem')
							.data('id'),
						fields: {
							wishlistQuantity: el.value
						},
						CRAFT_CSRF_TOKEN: token
					},
					json: true,
					type: 'form',
					success: function(response) {
						if (response.error || response.errors) {
							var message = response.error ||
								response.errors[Object.keys(response.errors)[0]];

							Apt.flash.error(message);

							return;
						}

						Apt.flash.success('Successfully updated quantity');
					},
					error: function(response) {
						if (response.error) {
							Apt.flash.error(response.error);
						}
					}
				});
			});
		}, {
			debounce: 200,
			namespace: 'wishlists'
		});

		$$('wishlistNote').on('click', function(e, el) {
			$(el).parent()
				.addClass('-is-active');
		}, {
			namespace: 'wishlists'
		});
	},

	/**
	 * Bind item reordering
	 */
	bindReorder: function() {
		var $items = $$('wishlistItem'),
			children = $items.toArray(),
			over,
			dragging;

		$items.prop('draggable', true)
			.on({
				dragstart: function(e, el) {
					dragging = el;

					el.classList.add('-is-dragging');
				},
				dragend: function(e, el) {
					el.classList.remove('-is-dragging');

					var items = {};

					children.forEach(function(el, index) {
						// Create individual update requests for each item's position
						Apt.auth.token(function(token) {
							$.fetch.request({
								url: '/',
								method: 'post',
								data: {
									action: 'wishlist/items/update',
									itemId: el.dataset.id,
									fields: {
										wishlistPosition: index + 1
									},
									CRAFT_CSRF_TOKEN: token
								},
								json: true,
								type: 'form',
								success: function(response) {
									if (response.error || response.errors) {
										var message = response.error ||
											response.errors[Object.keys(response.errors)[0]];

										Apt.flash.error(message);
									}
								}
							});
						});
					});

					Apt.flash.success('Updating item order...');
				},
				dragover: function(e, el) {
					e.preventDefault();

					var source = children.indexOf(dragging),
						target = children.indexOf(el);

					if (target === source) {
						return;
					}

					if (target > source) {
						el.after(dragging);
					} else {
						el.before(dragging);
					}

					children.splice(source, 1);
					children.splice(target, 0, dragging);
				},
				dragenter: function(e, el) {
					over = el;
				},
				dragleave: function() {
					over = null;
				}
			});
	},

	/**
	 * Bind list export
	 */
	bindExport: function() {
		var scope = this;

		$$('wishlistExport').on('click', function() {
			var filename = 'wishlist_' +
				new Date().toJSON()
					.slice(0, 10) + '.csv';

			scope.export(filename);
		}, {
			namespace: 'wishlists'
		});
	},

	/**
	 * Export list data
	 *
	 * @param filename
	 */
	export: function(filename) {
		var scope = this,
			universalBOM = "\uFEFF",
			csv = [],
			listId = $.get('listId') ?? null,
			url = listId ? '/wishlists/list/' + listId : '/wishlists/guest/';

		$.fetch.request({
			url: url,
			json: true,
			success: function(data) {
				if (! data.length) {
					return;
				}

				// Prepend header
				csv.push(Object.keys(data[0]));

				for (var i = 0; i < data.length; i++) {
					var item = data[i],
						row = [];

					for (var key in item) {
						row.push(item[key]);
					}

					csv.push(row);
				}

				scope.download(
					universalBOM + csv.join('\n'), filename
				);
			}
		});
	},

	/**
	 * Download CSV file
	 *
	 * @param csv
	 * @param filename
	 */
	download: function(csv, filename) {
		var link;

		csv = new Blob([csv], {
			type: 'text/csv'
		});

		link = document.createElement('a');
		link.download = filename;
		link.href = window.URL.createObjectURL(csv);
		link.style.display = 'none';

		document.body.appendChild(link);

		link.click();
	}
});
